export default () => ({
    hasEmptyFields: true,
    hasEmptyCode: true,
    captchaToken: null,
    email: null,
    password: null,
    code: null,
    turnstileWidgetId: null,

    init() {
        window.onCaptchaSuccess = (token) => {
            this.captchaToken = token;
            this.validate();
        }

        window.onloadTurnstileCallback = () => {
            const container = document.getElementById('turnstile-container');
            if (container && !this.turnstileWidgetId) {
                this.turnstileWidgetId = turnstile.render(container, {
                    sitekey: container.dataset.sitekey,
                    callback: window.onCaptchaSuccess
                });
            }
        };

        if (window.turnstile) {
            window.onloadTurnstileCallback();
        }
    },

    validateEmail() {
        this.email = this.$refs.email?.value;
        this.validate();
    },

    validatePassword() {
        this.password = this.$refs.password?.value;
        this.validate();
    },

    validateCode() {
        this.code = this.$refs.code?.value;
        this.validate();
    },

    validate() {
        if (document.getElementById('turnstile-container')) {
            this.hasEmptyFields = !this.email || !this.password || !this.captchaToken;
            this.hasEmptyCode = !this.code || !this.captchaToken
        } else {
            this.hasEmptyFields = !this.email || !this.password;
            this.hasEmptyCode = !this.code;
        }
    },

    btnClass() {
        return this.hasEmptyFields ? 'disabledButton' : 'mainButton';
    },

    btnClassCode() {
        return this.hasEmptyCode ? 'disabledButton' : 'mainButton';
    }
});